import {API} from 'aws-amplify'
import {UserModel} from '../../../../auth'
import {StockCategory} from './_models'

export const list = async (currentUser: UserModel, query: string) => {
  return API.get('app_base', `/organization/${currentUser.currentOrganization}/stock-category?${query}`, {})
}

export const get = async (id: string, currentUser: UserModel) => {
  const encodedUrl = encodeURIComponent(`/organization/${currentUser.currentOrganization}/stock-category/${id}`)
  return API.get('app_base', encodedUrl, {})
}

export const create = async (currentUser: UserModel, category: StockCategory) => {
  const encodedUrl = encodeURIComponent(`/organization/${currentUser.currentOrganization}/stock-category`)
  return API.post('app_base', encodedUrl, {body: category})
}

export const update = async (currentUser: UserModel, category: StockCategory) => {
  const encodedUrl = encodeURIComponent(`/organization/${currentUser.currentOrganization}/stock-category/${category.id}`)
  return API.put('app_base', encodedUrl, {body: category})
}

export const del = async (currentUser: UserModel, id: string) => {
  return API.del('app_base', `/organization/${currentUser.currentOrganization}/stock-category/${id}`, {})
}
